import { z } from 'zod';

/** The largest id the server's `bigint` columns hold: a larger value in the URL opens a fresh wizard. */
const INT8_MAX = 9_223_372_036_854_775_807n;

/**
 * Lodge from documents' search: `runId` is a bigint, which the router writes as plain digits
 * (`?runId=6`) and its parser reads back exactly (`utils/routing/parse-search.ts`). Coercion still
 * reads an old link that wrote it JSON-quoted (`?runId=%226%22`). Text that is not an integer is an
 * issue rather than a throw, so `.catch` opens a fresh wizard for it.
 */
export const aiLodgementSearchSchema = z.object({
    runId: z.coerce
        .bigint()
        .refine((value) => value > 0n && value <= INT8_MAX)
        .optional()
        .catch(undefined),
});
